import { useState } from "react"
import { GoButton } from "@imago/api-client-for-react"
import { ServiceProductInfo } from "@imago/model"
import { useProfile, useServiceProducts } from "../../api.ts"
import { Hello } from "../Hello.tsx"

function ServiceProductView({service}: {
	service: ServiceProductInfo
}) {
	const [detailsShown, setDetailsShown] = useState<boolean>(false)

	const profile = useProfile()
	const contactLink = 'mailto:support@imago.tg?' + new URLSearchParams({
		subject: `Book ${service.title}`,
		body: `Hello,\nI’d like to book ${service.title}.\n${profile?.shortName}`
	}).toString().replaceAll('+', '%20')
	return <article key={service.ID}>
		<hgroup onClick={ev => {
			if (ev.defaultPrevented) return
			ev.preventDefault()
			setDetailsShown(!detailsShown)
		}}>
			<h5>{service.title}</h5>
			<div role="toolbar">
				{detailsShown ? <></> : <GoButton className="low-prio only-on-medium-plus" href={contactLink} target="_blank">Contact us</GoButton>}
				<button>
					<span className="material-symbols-outlined">{detailsShown ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</span>
				</button>
			</div>
		</hgroup>
		<div dangerouslySetInnerHTML={{__html: service.description!}}/>
		{detailsShown ? <>
			<p>Price: {service.price} / session</p>
			<GoButton className="primary" href={contactLink} target="_blank">Contact us</GoButton>
			{service.bio ? <>
				<hr/>
				<aside dangerouslySetInnerHTML={{__html: service.bio!}}/>
			</> : <></>}
		</> : <></>}
	</article>
}

export function Services({fullScreen}: {fullScreen?: boolean}) {
	const Section = fullScreen ? 'main' : 'div'
	const H = fullScreen ? 'h1' : 'h2'
	const services = useServiceProducts()

	return <Section>
		{fullScreen ? <Hello/> : <></>}
		<section>
			<H>Book a service</H>
			{services ? [...services.values()].map(service => <ServiceProductView key={service.ID} service={service}/>) : <></>}
		</section>
		<section style={{marginTop: 20}}>
			<H>Share your feedback</H>
			<p>We’d love to hear about your experience. Your responses help us improve Imago.</p>
			<GoButton className="primary" href="https://forms.gle/tbTAMvT5bEFwNZW96" target="_blank">Open feedback survey</GoButton>
		</section>
	</Section>
}
